
<template>
  <div class="custom-control custom-radio custom-control-inline">
    <input type="radio" class="custom-control-input" v-bind:group="group" v-bind:id="id" v-bind:name="name" v-bind:value="value" v-bind:checked="checked" >
    <label class="custom-control-label" v-bind:for="id">{{text}}</label>
  </div>
</template>

<script>
	export default {
    name: 'testcomponent',
		components: {
		},
    props: [
      'value',
      'text',
      'alt',
      'placeholder',
      'name',
      'onchange',
      'checked',
      'id',
      'group'
    ],
    created() {
      
    },
    mounted() {
     
    }
}
</script>



// WEBPACK FOOTER //
// src/components/form-components/input-radio.vue